import { NgModule } from '@angular/core';
import {HttpClientModule, HTTP_INTERCEPTORS, HttpClientJsonpModule} from '@angular/common/http';
import { TokenInterceptor } from './provider/token.interceptor';
import { HttpRequestInterceptor } from './provider/http-request.interceptor';

@NgModule({
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			multi: true,
			useClass: TokenInterceptor
		},
		{
			provide: HTTP_INTERCEPTORS,
			multi: true,
			useClass: HttpRequestInterceptor
		}
	],
	exports: [
		HttpClientModule,
		HttpClientJsonpModule
	]
})
export class HttpCoreModule { }